import { apiFetcher } from '../fetcher';

export function getGenericQuery({
    queryKey: [_key],
}) {
    return apiFetcher(_key);
}

function getNonEmptySearchParams(allParams) {
    const params = Object.fromEntries(Object.entries(allParams).filter(([_, v]) => v !== ''));

    return new URLSearchParams(params);
}

export function getGameList({
    queryKey: [_key, params],
}) {
    const searchParams = getNonEmptySearchParams(params);

    return apiFetcher(`games/?${searchParams.toString()}`);
}

export function getStoryList({
    queryKey: [_key, {
        storyType, project, ...restParams
    }],
}) {
    const searchParams = getNonEmptySearchParams({ ...restParams, project });

    return apiFetcher(`v4/${project}/story/${storyType}/?${searchParams.toString()}`);
}

export function createVideo({ data }) {
    return apiFetcher('v4/media.vkplay.ru/videos/', {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
    });
}

export function getVideo({ id }) {
    return apiFetcher(`v4/media.vkplay.ru/videos/${id}/`, { method: 'GET' });
}

export function removeVideo({ id }) {
    return apiFetcher(`v4/media.vkplay.ru/videos/${id}/`, { method: 'DELETE' });
}

export function updateVideo({ id, data }) {
    return apiFetcher(`v4/media.vkplay.ru/videos/${id}/`, {
        method: 'PATCH',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
    });
}

export function getVideoList({
    queryKey: [, parameters],
}) {
    const searchParams = getNonEmptySearchParams(parameters);

    return apiFetcher(`v4/media.vkplay.ru/videos/?${searchParams.toString()}`);
}

export function removeStory({ id, project, storyType }) {
    return apiFetcher(`v4/${project}/story/${storyType}/${id}/`, { method: 'DELETE' });
}

export function getPocket({
    queryKey: [_key, {
        pocket, project, ...restParams
    }],
}) {
    const searchParams = getNonEmptySearchParams(restParams);

    return apiFetcher(`v4/${project}/pockets/${pocket}/?${searchParams.toString()}`);
}

export function storePocketData({ pocket, project, data }) {
    return apiFetcher(`v4/${project}/pockets/${pocket}/`, {
        method: 'PATCH',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
    });
}
